import { NgModule } from '@angular/core';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { LoadingBarComponent } from './svc-loading-bar.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';


@NgModule({
  declarations: [
    LoadingBarComponent,
  ],
  imports: [
    LibSharedCommonModule,
    MatProgressBarModule,
  ],
  exports: [
    LoadingBarComponent,
  ],
})
export class SvcLoadingBarModule { }